import { BaseApiConfiguration } from '../../common';
import { Http } from '../../common/api';

export const storeApiHttp = new Http();

export const initializeStoreApiHttp = (config: BaseApiConfiguration): void => {
  storeApiHttp.initializeHttp(`${config.baseUrl}`);
};
